// extracted by mini-css-extract-plugin
export const googleButton = "GoogleButton-module--googleButton--2LB-g";